import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEnvelope } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Auth.css";

const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState({ content: "", type: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!email) {
      setMessage({ content: "Email is required", type: "danger" });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMessage({ content: "Please enter a valid email address", type: "danger" });
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/employee/forgot-password`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to send reset email");
      }

      setMessage({
        content: data.message || "Password reset link sent to your email. Please check your inbox.",
        type: "success",
      });

      // Clear email field on success
      setEmail("");

    } catch (error) {
      setMessage({ 
        content: error.message || "An error occurred while sending reset instructions", 
        type: "danger" 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container forget-password-container">
      <div className="auth-card">
        <h2 className="text-center mb-4">Forgot Password?</h2>
        <p className="text-center text-muted mb-4">
          Enter your email address and we'll send you a link to reset your password.
        </p>

        {message.content && (
          <div className={`alert alert-${message.type}`} role="alert">
            {message.content}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group mb-3 position-relative">
            <FaEnvelope className="input-icon" />
            <input
              type="email"
              className="form-control auth-input"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={loading}
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>

        <div className="text-center mt-3">
          <a 
            href="/login" 
            className="auth-link"
            onClick={(e) => {
              e.preventDefault();
              navigate("/login");
            }}
          >
            Back to Login
          </a>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;